module.exports = __webpack_public_path__ + "sq20-5f22313e.png";